var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcOutlineMarkunreadMailboxCircle40Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20C0 8.9543 8.9543 0 20 0V0C31.0457 0 40 8.9543 40 20V20C40 31.0457 31.0457 40 20 40V40C8.9543 40 0 31.0457 0 20V20Z",
    fill: "#0033AD",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 14H18V16H28V28H12V16H14V20H16V12H22V8H14V14H12C10.9 14 10 14.9 10 16V28C10 29.1 10.9 30 12 30H28C29.1 30 30 29.1 30 28V16C30 14.9 29.1 14 28 14Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOutlineMarkunreadMailboxCircle40Px);
export default __webpack_public_path__ + "static/media/ic_outline-markunread_mailbox_circle-40px.306aeef3c569e99e1ba56fcc02e2ea72.svg";
export { ForwardRef as ReactComponent };